<template>
<div v-if="selected" id="eny_dashboard_overview" class="pt-8">
<div class="w-full flex justify-center">
	<div class="font-cooper font-bold text-color-text text-4xl py-2 pb-5">{{ $t('eny.ticket_message_history_title') }}</div>
</div>
		<ejs-grid ref="grid" :dataSource='ticketHistory' gridLines='Both' :allowTextWrap='true' height='570' allowSorting='true' :sortSettings='sortOptions' :queryCellInfo="customiseCell">
			<e-columns>
				<e-column field='id' headerText='ID' :isPrimaryKey='true' :visible='false'></e-column>
				<e-column field='sender' :headerText="$t('eny.ticket_cols.sender')"></e-column>
				<e-column field='prio' :headerText="$t('eny.ticket_cols.prio')" :dataSource='labels.prios' foreignKeyValue='label' foreignKeyField='value' width='100'></e-column>
				<e-column field='status' :headerText="$t('eny.ticket_cols.status')" :visible='isAdmin' :dataSource='labels.statuses' foreignKeyValue='label' foreignKeyField='value'></e-column>
				<e-column field='created_at' :headerText="$t('eny.ticket_cols.creation')" type="date" :format="{type: 'date', format: $t('eny.date_format')}" width='120'></e-column>
				<e-column field='due_date' :headerText="$t('eny.ticket_cols.due')" :visible='isAdmin' type="date" :format="{type: 'date', format: $t('eny.date_format')}" width='120'></e-column>
				<e-column field='text' :headerText="$t('eny.ticket_cols.text')"  width='300'></e-column>
				<e-column field='chanel' :headerText="$t('eny.ticket_cols.chanel')" :visible='isAdmin' :dataSource='labels.chanels' foreignKeyValue='label' foreignKeyField='value' width='100'></e-column>
			</e-columns>
		</ejs-grid>
	</div>
</template>

<script>
import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-vue-grids';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: "TicketHistory",
	props: ['selected', 'isAdmin'],
	components: {
		'ejs-grid': GridComponent,
		'e-columns': ColumnsDirective,
		'e-column': ColumnDirective,
	},
	data() {
		return {
			sortOptions: { columns: [{ field: 'created_at', direction: 'Descending' }] },
		};
	},
	methods: {
		...mapActions('ticket', ['loadTicketHistory', 'resetTicketHistory']),
		customiseCell: function(args) {
			const showLength=40;
			if (args.column.field === 'text') {
				if (args.cell.innerHTML.length>showLength) {
					args.cell.classList.add('eny-toolip');
					args.cell.tooltip = args.cell.innerHTML;
					args.cell.innerHTML = args.cell.innerHTML.slice(0, showLength) + "...";
				}
			}
    },
	},
	computed: {
		...mapGetters('ticket', ['ticketHistory', 'labels']),
		enyAdmin: function() {
			return this.$keycloak.hasRealmRole('admin');
		},
		isCustomer: function() {
			return this.$keycloak.hasRealmRole('customer');
		}
	},
	watch: {
		selected(value) {
			if (value) {
				this.loadTicketHistory(value);
			} else {
				this.resetTicketHistory();
			}
		},
	},
}
</script>

<style>
.e-grid .e-rowcell{
	font-size: 12px;
}
</style>
